<template>
    <v-row justify="space-between" align="center">
        <v-col cols="auto">
            <h3 class="tit tit--xs">재고리스트</h3>
        </v-col>
        <v-col cols="auto">
            <head-filter v-bind="{ loading }" />
        </v-col>
        <v-col cols="auto">
            <v-row class="row--xs">
                <v-col cols="auto">
                    <v-btn v-bind="{ loading }" color="grey lighten-3" outlined class="rounded-sm" @click="$emit('excel')">
                        <span class="grey--text">엑셀 다운로드</span>
                    </v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn v-bind="{ loading }" to="/mypage/inventory/shipping" color="grey lighten-3" outlined class="rounded-sm">
                        <span class="grey--text">재고 발송 내역</span>
                    </v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn v-bind="{ loading }" to="/mypage/inventory/details" color="primary" outlined class="rounded-sm">재고 입/출고 내역</v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import HeadFilter from "./head/head-filter.vue";

export default {
    components: {
        HeadFilter,
    },
    props: {
        loading: { type: Boolean, default: false },
    },
    setup: () => ({}),
    data: () => ({}),
    computed: {},
    methods: {},
    watch: {},
    mounted() {},
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped></style>
